import classNames from 'classnames';
import { dsClass } from '../../../common/constants/dsClasses';
import {
  contactDetailsMsg,
  customerServiceSolutionsMsg,
  devicesMsg,
  firstNameMsg,
  internetSubscriptionsMsg,
  itServicesMsg,
  lastNameMsg,
  marketingConsentMsg,
  mobileSubscriptionsMsg,
  networkAndInformationSecurityServicesMsg,
  otherMsg,
  professionalServicesOrTrainingMsg,
  submitMsg,
  t,
  workEmailMsg,
  workPhoneNumberMsg,
} from '../../../common/i18n/index.js';
import {
  FORM_GRID_FULL_WIDTH,
  FormGridFieldset,
} from '../../../common/react-hook-form/FormGridFieldset/FormGridFieldset.js';
import { Checkbox } from '../../../common/react-hook-form/components/Checkbox.js';
import { Dropdown } from '../../../common/react-hook-form/components/Dropdown.js';
import { CompanySearch } from '../../../common/react-hook-form/fields/CompanySearch.js';
import { Email } from '../../../common/react-hook-form/fields/Email.js';
import { Message } from '../../../common/react-hook-form/fields/Message.js';
import { Name } from '../../../common/react-hook-form/fields/Name.js';
import { PhoneNumber } from '../../../common/react-hook-form/fields/PhoneNumber.js';
import { Lead } from '../../../generated/api/models.js';
import { CustomFormErrorAndButton } from '../CustomFormFields.js';
import { PrivacyStatement } from './PrivacyStatement.js';
import type { CustomFormProps } from '.././CustomForm.js';

import './LeadForm.scss';

const InterestArea = () => (
  <Dropdown
    className={FORM_GRID_FULL_WIDTH}
    items={[
      {
        label: t.AR0B(mobileSubscriptionsMsg),
        value: Lead.InterestAreaEnum.MOBILE_SUBSCRIPTIONS,
      },
      {
        label: t.SEYV(internetSubscriptionsMsg),
        value: Lead.InterestAreaEnum.INTERNET_SUBSCRIPTIONS,
      },
      {
        label: t.JJTM(devicesMsg),
        value: Lead.InterestAreaEnum.DEVICES,
      },
      {
        label: t.JJTN(networkAndInformationSecurityServicesMsg),
        value: Lead.InterestAreaEnum.NETWORK_AND_INFORMATION_SECURITY_SERVICES,
      },
      {
        label: t.JJTO(itServicesMsg),
        value: Lead.InterestAreaEnum.IT_SERVICES,
      },
      {
        label: t.JJTP(customerServiceSolutionsMsg),
        value: Lead.InterestAreaEnum.CUSTOMER_SERVICE_SOLUTIONS,
      },
      {
        label: t.JJTQ(professionalServicesOrTrainingMsg),
        value: Lead.InterestAreaEnum.PROFESSIONAL_SERVICES_TRAINING,
      },
      {
        label: t.C6WY(otherMsg),
        value: Lead.InterestAreaEnum.OTHER,
      },
    ]}
    label={t.ZF7B('Which topic are you interested in?')}
    name="interestArea"
  />
);

export const LeadForm = ({ campaignId, leadFailed, leadInProgress, title }: CustomFormProps) => (
  <div className="of-lead-form">
    {title && <h2>{title}</h2>}
    <p className={classNames(dsClass.TEXT_S, dsClass.MARGIN_BOTTOM_4)}>
      {t.ONUM('All fields are mandatory, unless indicated as optional.')}
    </p>
    <FormGridFieldset legend={t.FV55(contactDetailsMsg)}>
      <div className={FORM_GRID_FULL_WIDTH}>
        <CompanySearch placeholder="" />
      </div>
      <Name label={t.AIK7(firstNameMsg)} name="firstName" placeholder="" />
      <Name label={t.Y41S(lastNameMsg)} name="lastName" placeholder="" />
      <Email label={t.ZVQ6(workEmailMsg)} placeholder="" />
      <PhoneNumber label={t.AGIK(workPhoneNumberMsg)} placeholder="" />
    </FormGridFieldset>
    <FormGridFieldset className="ds-margin-top--3">
      {!campaignId && <InterestArea />}
      <Message
        className={FORM_GRID_FULL_WIDTH}
        label={t.MTK8('Additional information (optional)')}
        placeholder=""
        rows={5}
      />
      <Checkbox className={FORM_GRID_FULL_WIDTH} label={t.GZUL(marketingConsentMsg)} name="consentForMarketing" />
      <PrivacyStatement />
    </FormGridFieldset>
    <CustomFormErrorAndButton buttonLabel={t.FSWU(submitMsg)} leadFailed={leadFailed} leadInProgress={leadInProgress} />
  </div>
);
